import type { EditorViewMode } from "ee/entities/IDE/constants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export const setIdeEditorViewMode = (mode: EditorViewMode) => {
  return {
    type: ReduxActionTypes.SET_IDE_EDITOR_VIEW_MODE,
    payload: {
      view: mode,
    },
  };
};

export const restoreIDEEditorViewMode = () => {
  return {
    type: ReduxActionTypes.RESTORE_IDE_EDITOR_VIEW_MODE,
  };
};

export const setIdeEditorPagesActiveStatus = (active: boolean) => {
  return {
    type: ReduxActionTypes.SET_IDE_EDITOR_PAGES_ACTIVE_STATUS,
    payload: {
      pagesActive: active,
    },
  };
};

export const setJSTabs = (tabs: string[]) => {
  return {
    type: ReduxActionTypes.SET_IDE_JS_TABS,
    payload: tabs,
  };
};

export const setQueryTabs = (tabs: string[]) => {
  return {
    type: ReduxActionTypes.SET_IDE_QUERIES_TABS,
    payload: tabs,
  };
};
